import { useEffect } from 'react';
import { AccommodationType } from '@aviv_price-pages/brand';
import { usePageLayoutContext } from '../usePageLayoutContext/usePageLayoutContext';
export const useAccommodationType = (indices) => {
    const { accommodationType, setAccommodationType } = usePageLayoutContext();
    useEffect(() => {
        if (!indices?.apartment) {
            setAccommodationType(AccommodationType.HOUSE);
        }
        if (!indices?.house && accommodationType === AccommodationType.HOUSE) {
            setAccommodationType(AccommodationType.APARTMENT);
        }
    }, [indices]);
    return { accommodationType, setAccommodationType };
};
